<template>
  <div class="notes-poi noteBox" role="presentation">
    <div class="content-header" role="presentation">
      <h3 v-if='poi' class='name-of-poi main-color'>{{ $tr(poi.name) }}<span style="color:grey;"> &middot; {{$store.state.college.name}}</span></h3>
    </div>
    <textarea
      :disabled="disabled"
      class="content-note"
      name="note"
      :value="note"
      @input="note = $event.target.value"
      ref="note"
      :placeholder="$t('notes.enterYourNoteHere')"
    ></textarea>
    <button
      class="btn edit-btn"
      @click="setFocus"
      v-if="disabled"
    >
      <span>{{ $t('notes.edit') }}</span>
    </button>
    <button class="btn edit-btn" @click="saveNote" v-else><span>{{ $t('notes.save') }}</span></button>
  </div>
</template>

<script>
import { mapGetters, mapActions, mapState } from 'vuex'

export default {
  name: 'PoiNotes',
  data: function () {
    return {
      disabled: false,
      note: ''
    }
  },
  created () {
    this.getNote()
  },
  beforeDestroy () {
    this.saveNote()
  },
  methods: {
    setFocus: function () {
      this.disabled = false
      this.$nextTick(() => { this.$refs.note.focus() })
    },
    getNote: function () {
      let note = this.getPOINote(this.poi)

      if (note && note.text) {
        this.note = note.text
        this.disabled = true
      } else {
        this.note = ''
        this.disabled = false
      }
    },
    saveNote: function () {
      if (this.note.length > 0) { this.disabled = true }
      this.updateStudentNote({ 'poi': this.poi, 'text': this.note })
    },
    ...mapActions('student', [
      'updateStudentNote'
    ])
  },
  computed: {
    ...mapState('poi', {
      poi: state => state.currentPoi
    }),
    ...mapGetters('student', [
      'getPOINote'
    ])
  },
  watch: {
    poi: function (newPoi, oldPoi) {
      this.getNote()
    }
  }
}
</script>
